module.exports = __webpack_public_path__ + "static/media/Leccion-4-23-Consagrando-mi-Vida-I.e7368304.pdf";